export default __webpack_public_path__ + "static/media/thumb-NavIC-Chip-4.f202fdb1.png";